import axios from 'axios'
import moment from 'moment'
import fileDownload from 'js-file-download'
import { APIServices } from './api.service'
import { ToastServices } from './toast.service'
import store from '../store'

const publicUploadImageUrl = `${APIServices.apiUrlV1}/uploads/public/images`
const uploadImageUrl = `${APIServices.apiUrlV1}/uploads/images`
const uploadFile = `${APIServices.apiUrlV1}/uploads/files`

export const CommonService = {
    uploadImage: async (file: File, isLogin = true) => {
        return new Promise((resolve, reject) => {
            // use fetch to convert file to blob
            fetch(file as any)
                .then((res) => res.blob())
                .then((blob) => {
                    const name = Math.random() * 10000000000
                    const newFile = new File([blob], `${name}.png`, {
                        type: blob.type,
                    })

                    // create new form data
                    const formData = new FormData()

                    // append the key, which is filename
                    formData.append('filename', newFile)

                    // upload action
                    const token = store?.getState()?.auth?.publicToken
                    // console.log(token)

                    const params = { token }
                    // const headers = APIServices.publicHeader()
                    const headers = APIServices.authenticationHeader()

                    let authChecked
                    if (!isLogin) {
                        authChecked = { params }
                    } else {
                        APIServices.axiosConfig()
                    }
                    axios
                        .post(
                            `${
                                isLogin ? uploadImageUrl : publicUploadImageUrl
                            }`,
                            formData,
                            authChecked
                        )
                        .then((response) => {
                            resolve(response.data)
                        })
                        .catch((error) => {
                            ToastServices.error(
                                error?.response?.data?.message ||
                                    'Unspecific error!'
                            )
                            reject(error?.response)
                        })
                })
        })
    },
    uploadFile: async (file: any) => {
        return new Promise((resolve, reject) => {
            // use fetch to convert file to blob
            fetch(file?.file as any)
                .then((res) => res.blob())
                .then((blob) => {
                    const newFile = new File(
                        [blob],
                        `${file?.filename}.${file?.extension}`,
                        {
                            type: blob.type,
                        }
                    )

                    // create new form data
                    const formData = new FormData()

                    // append the key, which is filename
                    formData.append('filename', newFile)

                    APIServices.axiosConfig()
                    axios
                        .post(uploadFile, formData)
                        .then((response) => {
                            resolve(response.data)
                        })
                        .catch((error) => {
                            ToastServices.error(
                                error?.response?.data?.message ||
                                    'Unspecific error!'
                            )
                            reject(error?.response)
                        })
                })
        })
    },
    preventNegativeNumber: (event: any, dotAllow = false) => {
        const blockedChars = ['e', 'E', '+', '-']
        const finalBlockedChars = dotAllow
            ? [...blockedChars, '.']
            : blockedChars
        return finalBlockedChars.includes(event?.key) && event.preventDefault()
    },

    phoneNumber: (event: any) => {
        const { charCode } = event
        const value = event?.target?.value

        // const limitedSpaces = value?.match(/\s/g)?.length < 5 && charCode === 32
        const containedLeftParenthesis = value?.includes('(') && charCode === 40
        const containedRightParenthesis =
            value?.includes(')') && charCode === 41
        const containedPlus = value?.includes('+') && charCode === 43
        // const containedMinus = value?.includes('-') && charCode === 45

        // spacial (' ', '(', ')', '+', '-')
        const spacial =
            // !limitedSpaces ||
            charCode === 40 ||
            charCode === 41 ||
            charCode === 43 ||
            charCode === 45 ||
            charCode === 32

        const numeric = charCode >= 48 && charCode <= 57

        const phoneNumberType = numeric || spacial

        return (
            (!phoneNumberType ||
                containedLeftParenthesis ||
                containedRightParenthesis ||
                // containedMinus ||
                containedPlus) &&
            event.preventDefault()
        )
    },

    textCapitalize: (text: string) => {
        if (!text) return
        const arr = text.split(' ')
        // loop through each element of the array and capitalize the first letter.
        // eslint-disable-next-line no-plusplus
        for (let i = 0; i < arr.length; i++) {
            arr[i] =
                arr[i].charAt(0).toUpperCase() + arr[i].slice(1).toLowerCase()
        }

        // Join all the elements of the array back into a string
        // using a blankspace as a separator
        return arr.join(' ')
    },

    currencyFormat: (number: number) => {
        if (!number) return '$0'
        return `$${parseFloat(String(number)).toFixed(2)}`
    },

    dateFormat: (date: string) => {
        if (!date) return ''
        return moment(date).format('MMM DD, yyyy')
    },

    // isFloat: (number) => {
    //     return Number(number) === number && number % 1 !== 0
    // },

    allowsInput: (
        event: any,
        accept: Array<'alphabet' | 'numeric' | 'space' | 'spacial'>
    ) => {
        const { charCode } = event
        let result: 'alphabet' | 'numeric' | 'space' | 'spacial' | '' = ''

        // space
        const space = charCode === 32

        // allow only alphabet
        const alphabet =
            (charCode > 64 && charCode < 91) ||
            (charCode > 96 && charCode < 123)
        const numeric = charCode >= 48 && charCode <= 57

        if (alphabet) {
            result = 'alphabet'
        } else if (numeric) {
            result = 'numeric'
        } else if (space) {
            result = 'space'
        } else {
            result = 'spacial'
        }

        return !accept.includes(result) && event.preventDefault()
    },

    downloadBlob(blobData: any, fileName: string, extension = 'xlsx') {
        const blob = new Blob([blobData])
        const url = window.URL.createObjectURL(blob)
        const a = document.createElement('a')
        document.body.appendChild(a)
        a.setAttribute('style', 'display: none')
        a.href = url
        a.download = `${fileName}.${extension}`
        a.click()
        window.URL.revokeObjectURL(url)
        a.remove()
    },

    downloadByUrl: (url: string, fileName: string) => {
        const a = document.createElement('a')
        document.body.appendChild(a)
        a.setAttribute('style', 'display: none')
        a.href = url
        a.download = `${fileName}`
        a.target = '_blank'
        a.click()
        window.URL.revokeObjectURL(url)
        a.remove()
    },
}
